import script from "./InventoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryPage.vue?vue&type=script&setup=true&lang=js"

import "./InventoryPage.vue?vue&type=style&index=0&id=0f6d0bfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6d0bfe"]])

export default __exports__